/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RolesControllerFindAllQueryResponse, RolesControllerFindAllQueryParams, RolesControllerFindAll401, RolesControllerFindAll403 } from "../../models/rolesController/RolesControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { rolesControllerFindAll } from "../../clients/rolesService/rolesControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const rolesControllerFindAllQueryKey = (params: RolesControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/roles'
}, ...(params ? [params] : [])] as const;
export type RolesControllerFindAllQueryKey = ReturnType<typeof rolesControllerFindAllQueryKey>;
export function rolesControllerFindAllQueryOptions(params?: RolesControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = rolesControllerFindAllQueryKey(params);
  return queryOptions<RolesControllerFindAllQueryResponse, ResponseErrorConfig<RolesControllerFindAll401 | RolesControllerFindAll403>, RolesControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return rolesControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get available roles (built-ins + caller org custom roles)
 * {@link /api/v1/roles}
 */
export function useRolesControllerFindAll<TData = RolesControllerFindAllQueryResponse, TQueryData = RolesControllerFindAllQueryResponse, TQueryKey extends QueryKey = RolesControllerFindAllQueryKey>(params?: RolesControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<RolesControllerFindAllQueryResponse, ResponseErrorConfig<RolesControllerFindAll401 | RolesControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? rolesControllerFindAllQueryKey(params);
  const query = useQuery({
    ...rolesControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<RolesControllerFindAll401 | RolesControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}